import Vue from "vue";
import Vuex from "vuex";
import { AppModule } from "@/modules/app.module";
import { AuthenticationModule } from "@/modules/authentication.module";
import { UiModule } from "@/modules/ui.module";
import { FalconPaymentsModule } from "@/modules/falcon/falcon-payments.module";
import { FalconDocumentsModule } from "@/modules/falcon/falcon-documents.module";
import { FalconComplaintsModule } from "@/modules/falcon/falcon-complaints.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...AppModule,
    ...UiModule,
    ...AuthenticationModule,
    ...FalconPaymentsModule,
    ...FalconDocumentsModule,
    ...FalconComplaintsModule
  }
});
